import { render, staticRenderFns } from "./editVoicePro.vue?vue&type=template&id=26fe4ddc&scoped=true"
import script from "./editVoicePro.vue?vue&type=script&lang=js"
export * from "./editVoicePro.vue?vue&type=script&lang=js"
import style0 from "./editVoicePro.vue?vue&type=style&index=0&id=26fe4ddc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fe4ddc",
  null
  
)

export default component.exports